import _ToolBar from '../../ToolBar.jsx'
import MenuButtonAiAgent from '../../menuButtons/MenuButtonAiAgent.jsx'
import MenuButtonEdit from '../../menuButtons/MenuButtonEdit.jsx'
import MenuButtonInsertNode from '../../menuButtons/MenuButtonInsertNode.jsx'
import MenuButtonInsertProducts from '../../menuButtons/MenuButtonInsertProducts.jsx'
import MenuButtonAi from './MenuButtonAi.jsx'
import MenuButtonAiGenerateFa from './MenuButtonAiGenerateFa.jsx'
import MenuButtonBranch from './MenuButtonBranch.jsx'
import MenuButtonCompareFirst from './MenuButtonCompareFirst.jsx'
import MenuButtonDataRelation from './MenuButtonDataRelation.jsx'
import MenuButtonExportSpec from './MenuButtonExportSpec.jsx'
import MenuButtonLint from './MenuButtonLint.jsx'
import MenuButtonMap from './MenuButtonMap.jsx'
import MenuButtonPublishProduct from './MenuButtonPublishProduct.jsx'
import MenuButtonPushProduct from './MenuButtonPushProduct.jsx'
import MenuButtonReviseProduct from './MenuButtonReviseProduct.jsx'
import MenuButtonSetParentRelation from './MenuButtonSetParentRelation.jsx'
import MenuButtonToggleCompareFirst from './MenuButtonToggleCompareFirst.jsx'

export default function ToolBar(props) {
    return (
        <_ToolBar {...props}>
            <div></div>

            <div>
                <MenuButtonMap />
                <MenuButtonEdit />
                <MenuButtonInsertNode type="common" />
                <MenuButtonInsertNode type="concept" />
                <MenuButtonInsertNode type="product" />
                <MenuButtonInsertProducts />
                <MenuButtonPushProduct />
                <MenuButtonPublishProduct />
                <MenuButtonReviseProduct />
                <MenuButtonAi />
                <MenuButtonExportSpec />
                <MenuButtonAiGenerateFa />
                <MenuButtonCompareFirst />
                <MenuButtonToggleCompareFirst />
                <MenuButtonLint />
                <MenuButtonBranch />
                <MenuButtonDataRelation />
                <MenuButtonSetParentRelation />
            </div>

            <div>
                <MenuButtonAiAgent />
            </div>
        </_ToolBar>
    )
}
